import { render, staticRenderFns } from "./response-score-breakdown.vue?vue&type=template&id=6882949a&scoped=true"
import script from "./response-score-breakdown.vue?vue&type=script&lang=js"
export * from "./response-score-breakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6882949a",
  null
  
)

export default component.exports